import { ReactNode, useState, useRef, useEffect } from 'react';

interface TooltipProps {
  children: ReactNode;
  content: string;
}

export const Tooltip = ({ children, content }: TooltipProps) => {
  const [show, setShow] = useState(false);
  const tooltipRef = useRef<HTMLDivElement>(null);
  const targetRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (show && tooltipRef.current && targetRef.current) {
      const targetRect = targetRef.current.getBoundingClientRect();
      const tooltipRect = tooltipRef.current.getBoundingClientRect();
      
      tooltipRef.current.style.left = `${targetRect.left + (targetRect.width / 2)}px`;
      tooltipRef.current.style.top = `${targetRect.top - tooltipRect.height - 8}px`;
    }
  }, [show]);

  return (
    <div className="relative inline-block" ref={targetRef}>
      <div
        onMouseEnter={() => setShow(true)}
        onMouseLeave={() => setShow(false)}
      >
        {children}
      </div>
      {show && (
        <div 
          ref={tooltipRef}
          className="fixed transform -translate-x-1/2 px-2 py-1 text-sm text-white bg-gray-900 rounded shadow-lg whitespace-nowrap z-[9999]"
        >
          {content}
          <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 translate-y-1/2 rotate-45 w-2 h-2 bg-gray-900" />
        </div>
      )}
    </div>
  );
};